import "./PrivacyStatement.module.css";
import Header from "@/reusable_sections/Header";
import Privacy from "./sections/Privacy";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyStatementPage() {
  return <div>
      <Header />
      <Privacy />
      <Footer />
    </div>;
}